import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { CompanyPreview } from 'src/app/core/interfaces/company-preview.interface';

@Component({
  selector: 'app-modal-new-user-request-company',
  templateUrl: './modal-first-company-added-finish.component.html',
  styleUrls: ['./modal-first-company-added-finish.component.scss']
})
export class ModalFirstCompanyAddedFinishComponent implements OnDestroy {
  private sessionCompany$: Observable<CompanyPreview>;
  companySession: CompanyPreview;
  destroy$ = new Subject();

  constructor(
    public dialogRef: MatDialogRef<ModalFirstCompanyAddedFinishComponent>,
    private readonly companySessionState: Store<{ company: CompanyPreview }>,
    @Inject(MAT_DIALOG_DATA) public data: { companyName: string }
  ) {
    this.sessionCompany$ = this.companySessionState.pipe(select('company'));
  }

  closeDialog() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
